export type TravellerDetailsConfigDay = {
  amendTo: string | null
  amendFrom: string | null
  isAmmend: boolean
  isOtherAirline: boolean
  isGdsIntl: boolean
  isSms: boolean
  isOffer: boolean
}

export type TravellerDetailsFlight = {
  id: number
  from: string
  to: string
  travelDate: string
}

export type TravellerDetailsPax = {
  id: number
  title: string
  lname: string
  fname: string
  paxType: string
}

export type TravellerDetailsResponse = {
  flightList: TravellerDetailsFlight[]
  paxInfoList: TravellerDetailsPax[]
  isRt: boolean
  isIntl: boolean
  isFullyAmmendable: boolean
  errorMessage: string | null
  clevertapKey: string | null
  isFlexiFlyTrip: boolean
  emailId: string
  configDaysMap: Record<string, TravellerDetailsConfigDay>
  contactMap: Record<string, string>
  vasDetails: unknown[]
  tripCountryCode: string
  cabinClass: string
  isNewFlowEnabled: boolean
  sft: string
  ct_upgrade: boolean
  eligibilityTier?: number
  fareDetails?: unknown[]
}

export type AmendmentSearchAPIData = {
  flightIds: number[]
  paxIds: number[]
  paxList: TravellerDetailsPax[]
  isRt: boolean
  from: string
  from_full: string
  to: string
  to_full: string
  depart_date: string
  return_date: string
  amend_from_date_depart: string
  amend_to_date_depart: string
  amend_from_date_return: string
  amend_to_date_return: string
  depart_date_formatted: string
  return_date_formatted: string
  intl: boolean
  vasDetails: unknown[]
  domain: string
  sourceType: string
  tripId: string
  isFullyAmmendable: boolean
  tripCountryCode: string
  fareDetails: unknown[]
  isFlexiFlyTrip: boolean
  configDaysMap: Record<string, TravellerDetailsConfigDay>
  isOfferAvailable: boolean
  ctUpgrade: boolean
  cabinClass: string
  sft: string
  isNewFlowEnabled: boolean
  onlyReturn?: boolean
}

export type AmendmentPassengerRow = {
  id: string
  fullName: string
  defaultSelected: boolean
}

export type AmendmentJourneyRow = {
  id: string
  routeLabel: string
  scheduledTime: string
  scheduledDateLabel: string
  originalTravelDateIso: string
  newDateFloatLabel: string
  newDatePlaceholder: string
  defaultSelected: boolean
}

export type AmendTravellerFulfillmentCase = {
  mobile: string
  email: string
  header: string
  message: string
}

export const emptyAmendTravellerFulfillmentCase = (): AmendTravellerFulfillmentCase => ({
  mobile: '',
  email: '',
  header: '',
  message: '',
})

export type AmendTravellerState = {
  amendmentsLoading: boolean
  notEligible: boolean
  apiFailed: boolean
  errorMessage: string
  eligibilityFailureCode: string
  userEmail: string
  isFlexiFlyIntlBooking: boolean
  ineligibleDueToOffer: boolean
  eligibilityTier: number | null
  isGdsIntl: boolean
  isSms: boolean
  travellerDetails: TravellerDetailsResponse | null
  passengers: AmendmentPassengerRow[]
  journeys: AmendmentJourneyRow[]
  isRoundTripCalendar: boolean
  searchAPIData: AmendmentSearchAPIData | Record<string, never>
  searchResults: Record<string, unknown>
  amendCaseFlowType: string
  amendCaseReason: string
  caseModalLoading: boolean
  fulfillmentFlag: boolean
  fulfillmentCase: AmendTravellerFulfillmentCase
  showErrorViewMsg: boolean
}

export type AmendFoxVasDetail = {
  vasType: string
  fareTypeMessage: string
  knowMoreLink: string
  vasStatus: string
  vasValidityDays: number
  preVasValidityDays: number
  vasStartDate: number
  vasEndDate: number
  vasExpirationDate: number
}

export type AmendFoxVasCalloutProps = {
  vasDetail: AmendFoxVasDetail
}

export type JourneyBenefitValidity = {
  label: string
  startDate: string
  endDate: string
}

export type AmendFoxBenefitValidityModalProps = {
  benefitValidityModalOpen: {
    isOnwardInValid: boolean
    isReturnInValid: boolean
  }
  onClose: () => void
  onSelectDifferentDates: () => void
  onContinueAnyway: () => void
  journeyValidities: JourneyBenefitValidity[]
  benefitType: string
  isRoundTrip: boolean
}
